<template>
  <div v-show="showModal" class="my_modal" ref="modalShow">
  <!-- <div class="my_modal" ref="modalShow"> -->
    <div class="my_modal_show">
      <el-row>
        <!-- <div class="top">
          <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" class="title">
            {{$t('ModalMsg.showModal.btn')}}
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <i class="el-icon-close" @click="showModal = false"></i>
          </el-col>
        </div> -->
        
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <p v-html="content" class="content"></p>
        </el-col>
        <div class="bottom-box">
          <label>
            <el-col :xs="2" :sm="1" :md="1" :lg="1" :xl="1">
              <el-checkbox v-model="checkStatus"></el-checkbox>
            </el-col>
            <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
              <p style="margin-top: 0px;" v-html="checkboxTxt"></p>
            </el-col>
          </label>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <p
              class="errors"
              style="margin-top: 0px;"
              v-show="!checkStatus"
            >{{$t('ModalMsg.showModal.errorsTxt')}}</p>
            <el-button
              style="float:right"
              type="primary"
              @click="hideModalFn"
              :disabled="!checkStatus"
              class="submitBtn"
            >{{$t('ModalMsg.showModal.btn')}}</el-button>
          </el-col>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showModal: Boolean,
    content: String,
    checkboxTxt: String
  },
  data() {
    return {
      checkStatus: false,
      clientHeight: 0
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.body.clientHeight}`;
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    hideModalFn() {
      this.$emit("controlModal", this.checkStatus);
    },
    changeFixed(clientHeight) {
      this.$refs.modalShow.style.height = clientHeight + "px";
    }
  }
};
</script>
<style lang='scss' scoped>
@media screen and (max-width: 500px) {
  .my_modal_show {
    position: fixed;
    top: 2%;
    left: 3%;
    width: 90%;
    padding: 0px 8px 8px 8px;
    border-radius: 4px;
    background-color: white;
    overflow: auto;
    border: 1px solid #ddd;
    width: 308px;
    height: 468px;
    top: 50%;
    bottom: auto;
    left: 50%;
    right: auto;
    margin-left: -171px;
    transform: translateY(-50%);
    // z-index: 999;
    // padding: 16px;
    // padding: 0;
  }
}
@media screen and (min-width: 501px) {
  .my_modal_show {
    position: fixed;
    top: 8%;
    left: 25%;
    width: 50%;
    // padding: 30px;
    border-radius: 4px;
    background-color: white;
    overflow: auto;
    border: 1px solid #ddd;
  }
}
.my_modal {
  position: absolute;
  z-index: 9999999999999999;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.6);
  pad: 0;
  .errors {
    color: #f56c6c;
    font-size: 12px;
  }
}
.my_modal_show {
  // font-family: Roboto;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.69;
  letter-spacing: normal;
  padding: 16px;
  .top {
    // width: 100%;
    // height: 30px;
    // position: fixed;
    // top: 0;
    // left: 0;
  }
  .title {
    text-transform: uppercase;
  }
  .el-icon-close {
    float: right;
  }
  .submitBtn {
    width: 80%;
    line-height: 22px;
    text-align: center;
    float: none !important;
    text-transform: uppercase;
    display: block;
    margin: 0 auto;
  }
  .content {
    // height: 220px;
    // overflow-y: auto;
    // border-bottom: 1px solid #25282c;
    // margin: 0;
    // padding: 0;
  }
  .bottom-box {
    // height: 300px;
    // width: 100%;
    // position: fixed;
    // bottom: 0;
    // left: 0;
    // background: #f56c6c;
  }
}
label,
.errors {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/modal.vue